






















































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import InfomationForm from '@/components/organisms/InfomationForm.vue';
import AboutEdit from '@/components/molecules/AboutEdit.vue';
import HeadlineEdit from '@/components/molecules/HeadlineEdit.vue';
import MenuEdit from '@/components/molecules/MenuEdit.vue';
import HolidayEdit from '@/components/molecules/HolidayEdit.vue';
import UsersList from '@/components/organisms/UsersList.vue';
import {GlobalConstants} from '@/common/constants';
import {HTMLElementEvent} from '@/model/interfaces/extends-interface';
import _ from 'lodash';

@Component({
  components: {
    'about-edit-viewer': AboutEdit,
    'headline-edit-viewer': HeadlineEdit,
    'menu-edit-viewer': MenuEdit,
    'infomation-form': InfomationForm,
    'users-list': UsersList,
    'holiday-edit-viewer': HolidayEdit,
  }
})
export default class AccountViewer extends Vue {

  private time: number = 1000;
  private created: string = '';
  private items: any = [
    { icon: true, title: 'アカウント情報編集', icon_name: 'account_box' },
    { icon: true, title: 'メニュー', icon_name: 'mdi-help-box' },
    { icon: true, title: 'お店について', icon_name: 'mdi-help-box' },
    { icon: true, title: 'ヘッドライン情報', icon_name: 'info' },
    { icon: true, title: 'ショップ情報', icon_name: 'info' },
    { icon: true, title: '休日', icon_name: 'holiday' }
  ];
  private model: string = 'tab-0';
  private tabs = null;

  /** Data **/
  /** Computed **/
  get userId() {
    return userModule.userId;
  }

  get userName() {
    return userModule.userName;
  }

  get innerWidth() {
    return contentsModule.innerWidth;
  }

  get text() {
    return {
      loginpath: GlobalConstants.LOGIN.PATH,
      name: GlobalConstants.TEXT.DIGITALBADGE.NAME,
      getBadge: GlobalConstants.TEXT.DIGITALBADGE.GETBADGE,
      badgeType: GlobalConstants.TEXT.DIGITALBADGE.BADGETYPE,
      contents: GlobalConstants.TEXT.DIGITALBADGE.CONTENTS,
      publish: GlobalConstants.TEXT.DIGITALBADGE.PUBLISH,
      cool: GlobalConstants.TEXT.DIGITALBADGE.COOL,
      posts: GlobalConstants.TEXT.DIGITALBADGE.POSTS,
      title: GlobalConstants.TEXT.ACCOUNT.TITLE
    };
  }

  get isLogin() {
    return userModule.userName !== '' && appModule.token !== '';
  }

  /** Methods **/
  private async onLogout() {
    appModule.startLoading();
    userModule.clearStrage();
    await appModule.requestLogoutInfo().catch(err => {
      this.errorPropagation(err);
    });
    setTimeout(() => {
      const path = this.text.loginpath;
      this.$router.push({ path: `${path}`}).catch(err => err);
      appModule.stopLoading();
    }, 1000);
  }

  private onClick(e: HTMLElementEvent<HTMLInputElement>, item: any) {
    // console.log('onClick--- ', item, e);
    if (userModule.userId !== '') {
    } else {
      setTimeout(() => {
        const path = this.text.loginpath;
        this.$router.push({ path: `${path}`}).catch(err => err);
        appModule.stopLoading();
      }, 1000);
    }
  }

  /** Watch **/

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    appModule.startLoading();
    const token = this.$route.query.token ?? userModule.apiToken;
    contentsService.setBreadcrumb(this.$route.path, 'account', null, null, null, null, `${token}`);
    appModule.stopLoading();
  }

}
